// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import Card from '@mui/material/Card';
// import CardContent from '@mui/material/CardContent';
// import Typography from '@mui/material/Typography';
// import Grid from '@mui/material/Grid';
// import Button from '@mui/material/Button';
// import IconButton from '@mui/material/IconButton';
// import Chip from '@mui/material/Chip';
// import LinearProgress from '@mui/material/LinearProgress';
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import CategoryIcon from '@mui/icons-material/Category';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import AddIcon from '@mui/icons-material/Add';
// import DownloadIcon from '@mui/icons-material/Download';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import { BarChart } from '@mui/x-charts/BarChart';
// import { LineChart } from '@mui/x-charts/LineChart';

// // Mock data
// const subjectPerformanceData = [
//   { subject: 'Mathematics', performance: 85 },
//   { subject: 'Science', performance: 78 },
//   { subject: 'English', performance: 72 },
//   { subject: 'History', performance: 80 },
//   { subject: 'Geography', performance: 68 },
// ];

// const performanceTrendData = [
//   { month: 'Oct 05', score: 65 },
//   { month: 'Oct 08', score: 75 },
//   { month: 'Mar 05', score: 70 },
//   { month: 'Mar 10', score: 78 },
//   { month: 'Nov 15', score: 85 },
// ];

// const topicMasteryData = [
//   { topic: 'Algebra - Linear Equations', progress: 95, status: 'Mastered', color: '#4caf50' },
//   { topic: 'Algebra - Quadratic Equations', progress: 90, status: 'Mastered', color: '#4caf50' },
//   { topic: 'Geometry - Triangles', progress: 85, status: 'Mastered', color: '#4caf50' },
//   { topic: 'Physics - Newton\'s Laws', progress: 82, status: 'Mastered', color: '#4caf50' },
//   { topic: 'Chemistry - Chemical Reactions', progress: 65, status: 'Moderate', color: '#ff9800' },
//   { topic: 'Geometry - Shapes', progress: 55, status: 'Moderate', color: '#ff9800' },
// ];

// const studentPerformanceDistData = [90, 85, 70, 60, 88];

// const studentWeaknessData = [
//   { name: 'Emma Johnson', score: '54%', status: 'Strong', performance: 'Excellent', topics: ['Geometry', 'Trigonometry'] },
//   { name: 'Noah Griffin', score: '32%', status: 'Strong', performance: null, topics: ['Algebra', 'Geometry'] },
//   { name: 'Olivia Brown', score: '12%', status: 'Weak', performance: null, topics: ['Algebra', 'Geometry'] },
//   { name: 'Liam Davis', score: '60%', status: 'Needs Help', performance: null, topics: ['Linear Equations', 'Geometry'] },
//   { name: 'Ava Wilson', score: '88%', status: 'Strong', performance: 'Probability', topics: null },
// ];

// const topicAnalysisData = [
//   { topic: 'Algebra', avg: '75%', weakStudents: ['John Smith', 'Jane Doe', 'Mike Brown'] },
//   { topic: 'Geometry', avg: '68%', weakStudents: ['Sarah Johnson', 'David Lee', 'Emma Davis'] },
//   { topic: 'Statistics', avg: '82%', weakStudents: ['Daniel Brown'] },
//   { topic: 'Trigonometry', avg: '71%', weakStudents: ['Lisa Miller', 'Tom Wilson'] },
// ];

// const ParentDashboard = () => {
//   const [selectedStudent, setSelectedStudent] = useState('Emma Johnson (Grade 8)');

//   return (
//     <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
//       {/* Header */}
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a237e' }}>
//             Parent Dashboard
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Track your child's academic progress
//           </Typography>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//           <FormControl size="small" sx={{ minWidth: 200 }}>
//             <Select value={selectedStudent} onChange={(e) => setSelectedStudent(e.target.value)}>
//               <MenuItem value="Emma Johnson (Grade 8)">Emma Johnson (Grade 8)</MenuItem>
//               <MenuItem value="John Doe (Grade 9)">John Doe (Grade 9)</MenuItem>
//             </Select>
//           </FormControl>
//           <Button variant="outlined" startIcon={<AddIcon />}>Create Test</Button>
//           <Button variant="contained" startIcon={<DownloadIcon />}>Download Report</Button>
//         </Box>
//       </Box>

//       {/* Stats Cards */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Overall Performance
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     85%
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Above average
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <TrendingUpIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Tests Completed
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     5
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     This semester
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <AssessmentIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Strong Topics
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     4
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Mastered areas
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <CategoryIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Focus Areas
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     2
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Needs improvement
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <VisibilityIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Charts Row */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         <Grid item xs={12} md={6}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                 Subject-wise Performance
//               </Typography>
//               <BarChart
//                 xAxis={[{ scaleType: 'band', data: subjectPerformanceData.map(d => d.subject) }]}
//                 series={[{ data: subjectPerformanceData.map(d => d.performance), label: 'Performance (%)' }]}
//                 height={300}
//               />
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                 Performance Trend
//               </Typography>
//               <LineChart
//                 xAxis={[{ scaleType: 'band', data: performanceTrendData.map(d => d.month) }]}
//                 series={[{ data: performanceTrendData.map(d => d.score), label: 'Score (%)' }]}
//                 height={300}
//               />
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Bottom Row */}
//       <Grid container spacing={3}>
//         <Grid item xs={12} md={6}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                 Topic-wise Mastery
//               </Typography>
//               {topicMasteryData.map((item, index) => (
//                 <Box key={index} sx={{ mb: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                     <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                       {item.topic}
//                     </Typography>
//                     <Chip 
//                       label={item.status} 
//                       size="small" 
//                       sx={{ 
//                         bgcolor: item.color, 
//                         color: 'white',
//                         fontWeight: 600,
//                         fontSize: '0.7rem'
//                       }} 
//                     />
//                   </Box>
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <LinearProgress 
//                       variant="determinate" 
//                       value={item.progress} 
//                       sx={{ 
//                         flex: 1, 
//                         height: 8, 
//                         borderRadius: 4,
//                         bgcolor: '#e0e0e0',
//                         '& .MuiLinearProgress-bar': {
//                           bgcolor: item.color
//                         }
//                       }} 
//                     />
//                     <Typography variant="caption" sx={{ minWidth: 40, textAlign: 'right' }}>
//                       {item.progress}% correct
//                     </Typography>
//                   </Box>
//                 </Box>
//               ))}
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} md={6}>
//           <Card>
//             <CardContent>
//               <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//                 Knowledge Map
//               </Typography>

//               <Box sx={{ mb: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#4caf50' }} />
//                   <Typography variant="body2" sx={{ fontWeight: 600 }}>Strong Areas</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   <Chip label="Linear Equations" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
//                   <Chip label="Triangles" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
//                   <Chip label="Newton's Laws" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
//                   <Chip label="World History" size="small" sx={{ bgcolor: '#e8f5e9', color: '#2e7d32' }} />
//                 </Box>
//               </Box>

//               <Box sx={{ mb: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ff9800' }} />
//                   <Typography variant="body2" sx={{ fontWeight: 600 }}>Moderate Areas</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   <Chip label="Quadratic Equations" size="small" sx={{ bgcolor: '#fff3e0', color: '#e65100' }} />
//                   <Chip label="Shapes" size="small" sx={{ bgcolor: '#fff3e0', color: '#e65100' }} />
//                   <Chip label="Chemical Reactions" size="small" sx={{ bgcolor: '#fff3e0', color: '#e65100' }} />
//                 </Box>
//               </Box>

//               <Box>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#f44336' }} />
//                   <Typography variant="body2" sx={{ fontWeight: 600 }}>Needs Focus</Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   <Chip label="Complexity Maps" size="small" sx={{ bgcolor: '#ffebee', color: '#c62828' }} />
//                   <Chip label="Complex Fractions" size="small" sx={{ bgcolor: '#ffebee', color: '#c62828' }} />
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };

// const TeacherDashboard = () => {
//   const [selectedClass, setSelectedClass] = useState('Mathematics');

//   return (
//     <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
//       {/* Header */}
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a237e' }}>
//             Teacher Dashboard
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Monitor and analyze class performance
//           </Typography>
//         </Box>
//         <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//           <FormControl size="small" sx={{ minWidth: 150 }}>
//             <Select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
//               <MenuItem value="Mathematics">Mathematics</MenuItem>
//               <MenuItem value="Science">Science</MenuItem>
//               <MenuItem value="English">English</MenuItem>
//             </Select>
//           </FormControl>
//           <Button variant="outlined" startIcon={<AddIcon />}>Create Test</Button>
//           <Button variant="contained" startIcon={<DownloadIcon />}>Export Report</Button>
//         </Box>
//       </Box>

//       {/* Stats Cards */}
//       <Grid container spacing={3} sx={{ mb: 3 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Total Students
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     5
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Active learners
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <MoreVertIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Average Score
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     78.5%
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Class performance
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <AssessmentIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Completion Average
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     81.2%
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     Test completion
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <AssessmentIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>

//         <Grid item xs={12} sm={6} md={3}>
//           <Card>
//             <CardContent>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary" gutterBottom>
//                     Students Needing Support
//                   </Typography>
//                   <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
//                     1
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     At risk
//                   </Typography>
//                 </Box>
//                 <IconButton size="small">
//                   <VisibilityIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>

//       {/* Student Performance Distribution */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//             Student Performance Distribution
//           </Typography>
//           <BarChart
//             xAxis={[{ scaleType: 'band', data: ['90-100', '80-89', '70-79', '60-69', '50-59'] }]}
//             series={[{ data: [28, 25, 20, 18, 27], label: 'Performance (%)', color: '#4caf50' }]}
//             height={250}
//           />
//         </CardContent>
//       </Card>

//       {/* Student Weakness Analysis */}
//       <Card sx={{ mb: 3 }}>
//         <CardContent>
//           <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//             Student Weakness Analysis
//           </Typography>
//           <Box sx={{ overflowX: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//               <thead>
//                 <tr style={{ borderBottom: '2px solid #e0e0e0' }}>
//                   <th style={{ textAlign: 'left', padding: '12px', fontWeight: 600 }}>Student Name</th>
//                   <th style={{ textAlign: 'center', padding: '12px', fontWeight: 600 }}>Overall Performance</th>
//                   <th style={{ textAlign: 'center', padding: '12px', fontWeight: 600 }}>Weak Topics</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {studentWeaknessData.map((student, index) => (
//                   <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
//                     <td style={{ padding: '12px' }}>{student.name}</td>
//                     <td style={{ padding: '12px', textAlign: 'center' }}>
//                       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
//                         <Typography variant="body2">{student.score}</Typography>
//                         <Chip 
//                           label={student.status} 
//                           size="small"
//                           sx={{ 
//                             bgcolor: student.status === 'Strong' ? '#e8f5e9' : student.status === 'Weak' ? '#ffebee' : '#fff3e0',
//                             color: student.status === 'Strong' ? '#2e7d32' : student.status === 'Weak' ? '#c62828' : '#e65100',
//                             fontWeight: 600
//                           }}
//                         />
//                       </Box>
//                     </td>
//                     <td style={{ padding: '12px' }}>
//                       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, flexWrap: 'wrap' }}>
//                         {student.topics?.map((topic, idx) => (
//                           <Chip key={idx} label={topic} size="small" />
//                         ))}
//                         {student.performance && (
//                           <Chip label={student.performance} size="small" />
//                         )}
//                       </Box>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </Box>
//         </CardContent>
//       </Card>

//       {/* Topic-wise Analysis */}
//       <Card>
//         <CardContent>
//           <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
//             Topic-wise Analysis
//           </Typography>
//           {topicAnalysisData.map((topic, index) => (
//             <Box key={index} sx={{ mb: 3, pb: 2, borderBottom: index < topicAnalysisData.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography variant="body1" sx={{ fontWeight: 600 }}>
//                   {topic.topic}
//                 </Typography>
//                 <Chip label={`${topic.weakStudents.length} students need support`} size="small" variant="outlined" />
//               </Box>
//               <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                 Class Average: {topic.avg}
//               </Typography>
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 <Typography variant="caption" color="text.secondary">Weak Students:</Typography>
//                 {topic.weakStudents.map((student, idx) => (
//                   <Chip key={idx} label={student} size="small" sx={{ bgcolor: '#f5f5f5' }} />
//                 ))}
//               </Box>
//             </Box>
//           ))}
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// // Main App Component with Toggle
// const App = () => {
//   const [view, setView] = useState('parent');

//   return (
//     <Box>
//       <Box sx={{ bgcolor: '#1a237e', color: 'white', p: 2, textAlign: 'center' }}>
//         <Button 
//           variant={view === 'parent' ? 'contained' : 'outlined'} 
//           onClick={() => setView('parent')}
//           sx={{ mr: 2, color: view === 'parent' ? '#1a237e' : 'white', bgcolor: view === 'parent' ? 'white' : 'transparent', borderColor: 'white' }}
//         >
//           Parent Dashboard
//         </Button>
//         <Button 
//           variant={view === 'teacher' ? 'contained' : 'outlined'} 
//           onClick={() => setView('teacher')}
//           sx={{ color: view === 'teacher' ? '#1a237e' : 'white', bgcolor: view === 'teacher' ? 'white' : 'transparent', borderColor: 'white' }}
//         >
//           Teacher Dashboard
//         </Button>
//       </Box>
//       {view === 'parent' ? <ParentDashboard /> : <TeacherDashboard />}
//     </Box>
//   );
// };

// export default App;

import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ParentDashboard from './ParentDashboard.tsx';
import TeacherDashboard from './TeacherDashboard.tsx';
// import PerformanceMap from './PerformanceMap.tsx';

const ParentTeacherDashboard: React.FC = () => {
  const { type } = useParams<{ type: string }>();

  if (type === 'parent') return <ParentDashboard />;
  if (type === 'teacher') return <TeacherDashboard />;
  // if (type === 'performanceMap') return <PerformanceMap />;

  return <Navigate to="/r/404" replace />;
};

export default ParentTeacherDashboard;
